'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.requires.push('bgf.paginateAnything');

EwSiteApp.controller('NaturaltestPreviewCtrl',['$scope', '$http', '$sce', function ($scope, $http, $sce) {
	$scope.historyDataUrl = naturaltestData.historyDataUrl;
	$scope.attDataUrl = naturaltestData.attDataUrl;
	$scope.startingPageHistory = 0;
	$scope.startingPage = 0;
	$scope.reloadPage = false;
//	$scope.loading = false;
	$scope.item = {
		history: [],
		attachments: []
	};
}]);